/* eslint-disable import/no-anonymous-default-export */
export default {
  translations: { // Mesmo valor usado nas configurações (defaultNS)
    menu: {
      examsTitle: 'Gravações',
      dicomTitle: 'Imagens',
      medicalReportsTitle: 'Resultados',
      reportsTitle: 'Relatórios',
      customizationTitle: 'Customização',
      marketingTitle: 'Marketing',
      hooksFleuryTitle: 'Hooks Fleury',
      mp4ReprocessTitle: 'Reprocessar MP4',
      communicationTitle: 'Central de comunicação',
      financialTitle: 'Área financeira',
      storageTitle: 'Armazenamento',
      goOutTitle: 'Sair',
      maternityBookletTitle: 'Caderneta da Gestante',
      learnMore: 'saiba mais',
      user: 'Usuário',
      platform: 'Plataforma',
    },

    home: {
      noPeriodSelected: 'Nenhum período selecionado',
      notFoundData: 'Dados não encontrados.',
      errorLoadingData: 'Ocorreu um erro ao carregar os dados.',
      tryAdmContact: 'Entre em contato com o seu administrador!',
      timeoutError: 'O tempo limite de requisição foi excedido.',
    },

    appEnabled: {
      noData: 'Dados insuficientes.',
      insufficient_data: "Dados insuficientes.",
      clear_filters_try_again: "Limpe seus filtros e tente novamente",
      v_baby_fleury: "V-Baby na sua marca",
      active_brands: "Marcas Ativas",
      units: "Unidades",
      installed_equipment: "Equipamentos Instalados",
      previous_interval: "intervalo anterior",
      curiosities: "Curiosidades",
      top_5_content_watched: "Top 5 conteúdos mais assistidos pelas mamães da sua clínica:",
      most_popular_baby_name: "Você sabe qual o nome de bebê mais popular por aí?",
      other_popular_names: "Outros nomes fazendo sucesso:",
      did_you_know_videos_podcasts: "Você sabia? Suas mamães preferem vídeos e podcasts do que artigos.",
      data_not_found: "Dados insuficientes",
      total_exams: 'Exames realizados',
      booking_clicks: 'Cliques em agendamento',
      exam_view_quantity: 'Visualizações de exames',
      baby_users_quantity: 'Pacientes no App',
      articles_read: "Artigos lidos",
      videos_podcasts_watched: "Vídeos e podcasts assistidos",
      logo_share: 'Marca compartilhada',
      vbabySharesByMoms: 'Número de vezes que um video com moldura foi salvo ou compartilhado!',
      insights: 'Insights',
      reviews: 'Avaliações',
      overview: 'Overview',
      share: 'Compartilhar',
      totalRatings: 'Total de avaliações',
      averageRatings: 'Média de avaliação do app',
      ratingsWithComments: 'Avaliações com comentários',
      noRatingsFound: 'Nenhuma avaliação encontrada',

      superFeedbackTooltip: 'Super feedback',
      alertFeedbackTooltip: 'Sinal de alerta',
      criticalFeedbackTooltip: 'Crítico',

      vbabyContentsAccessedByMoms: 'Confira quantos conteúdos informativos do V-Baby foram acessados pelas mamães!',
      vbabyInformationalContentViews: 'Visualizações de conteúdos informativos V-Baby',

      vbabyExamsPatients: 'Pacientes no V-Baby e Exames realizados',

      vbabyDailyUsageAndExams: 'Descubra quantas mamães já realizaram exames e quantas estão usando o aplicativo V-Baby por dia!',

      momsFeedbacks: 'Feedbacks das mamães',

      week: 'semana ',

      topFiveContents: 'Top 5 conteúdos mais assistidos pelas mamães:',

      readMore: 'Leia mais',

      topMostWatchedContents: 'Top 5 conteúdos mais assistidos pelas mamães da sua clínica:',
      momsPreferences: 'Você sabia?',
      videosFavorites: 'Você sabia? As mamães preferem vídeos e podcasts do que artigos.',
      articlesFavorites: 'Você sabia? As mamães preferem artigos do que vídeos e podcasts.',
      articlesRead: ' artigos lidos',
      videosWatched: ' vídeos e podcasts assistidos',

      appCuriositiesMomSuccess: 'As curiosidades no app estão fazendo sucesso com suas mamães!',
      were: 'Foram',
      sharings: '{{sharings}} compartilhamentos',
      thisWeek: 'só essa semana!',

      mostFamousFrame: 'A moldura que mais tem feito sucesso entre as mamães da ',
      mostFamousFrameNotFounded: 'A moldura que mais tem feito sucesso entre as mamães ',

      isTheOne: 'é a do ',
      noFrameDataFounded: 'Nenhum dado sobre moldura encontrado!',

      mostFamousBabyName: 'Você sabe qual o nome de bebê mais popular por aí?',
      is: 'É',
      vbabyTotalFamousName: 'Temos {{value}} ao todo no V-Baby agora mesmo!',
      othersSuccessNames: 'Outros nomes fazendo sucesso:',

      vbabyViewers: 'Suas pacientes adoraram a transmissão ao vivo no V-Baby!',
      live: 'LIVE',
      quantityMomsParticipating: 'Só da {{organization}} foram {{quantity}} mamães participando com a gente!',
      quantityMomParticipating: 'Só da {{organization}} foi 1 mamãe participando com a gente!'
    },

    appDisabled: {
      total_exams: 'Exames realizados',
      sharingClicks: 'Cliques em compartilhar exame',
      exam_view_quantity: 'Visualizações de exames',
      baby_users_quantity: 'Pacientes no App',
      momsFeedbacks: 'Feedbacks das mamães',
      score: 'Nota:',
      feedbackAt: '{{date}} às {{time}}'
    },

    notFoundedPage: 'Página não encontrada!',
    goBack: 'Voltar',

    components: {
      selectOrganization: 'Selecione uma organização',
      filter: 'Filtros',
      results: 'Ver resultados',
      refreshButton: 'Atualizar',

      calendar: {
        thisMonth: 'Este mês',
        lastThirtyDays: 'Últimos 30 dias',
        lastFifteenDays: 'Últimos 15 dias',
        lastSevenDays: 'Últimos 7 dias',
        today: 'Hoje',
        yesterday: 'Ontem',
        to: 'até',
        clear: 'Limpar',
        apply: 'Aplicar'
      },

      lineChart: {
        total_exams: 'Exames realizados',
        vbabyPatients: 'Pacientes VBaby',
        date: 'Data:',
        accessDate: 'Data de acesso/exame',
        numberPatientsExams: 'N° de Pacientes e Exames',
      },

      pagination: {
        resultsPage: 'resultados por página',
        results: 'resultados',
        "page": "página",
        "of": "de"
      },

      "tabs": {
        "feedbacks": "Feedbacks",
        "ratings": "Avaliações"
      },
      
      "ratings": {
        "averageRating": "Média de avaliações do app"
      }
    },

    recap: {
      results: 'Veja seus resultados incríveis de 2024!',
      milestones: 'Reunimos os seus marcos deste ano com o V-Baby.',
    },
    expiredToken: "Sessão expirada. Redirecionando para a tela de login em 5 segundos."
  }
}